export const RETAIL_CONVERSATIONAL_OPERATIONAL = 'retail-klant-conversational.operational';
